import baseApi from "../api/baseApi";

const instructorTags = [{ type: "Instructors", id: "LIST" }];

const invalidateInstructorCache = async (
  _arg,
  { dispatch, queryFulfilled },
) => {
  try {
    await queryFulfilled;
    dispatch(baseApi.util.invalidateTags(instructorTags));
  } catch {
    // Keep cached data when the mutation fails.
  }
};

const instructorApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getVerifiedAndUnverifiedInstructors: builder.query({
      query: () => ({
        url: "/instructor/getVerifiedAndUnverifiedInstructors",
        method: "GET",
        credentials: "include",
      }),
      providesTags: instructorTags,
    }),

    changeInstructorStatus: builder.mutation({
      query: ({ instructorId, accountStatus }) => ({
        url: "/user/changeInstructorStatus",
        method: "PATCH",
        credentials: "include",
        body: {
          instructorId,
          accountStatus,
        },
      }),
      invalidatesTags: instructorTags,
    }),
  }),
});

export const {
  useGetVerifiedAndUnverifiedInstructorsQuery,
  useLazyGetVerifiedAndUnverifiedInstructorsQuery,
  useChangeInstructorStatusMutation,
} = instructorApi;
